<div class="hour-input-wrapper">
  <div class="hour-input-container" [ngStyle]="{ padding }">
    <input
      #hoursInput
      class="time-input"
      type="number"
      [formControl]="hoursControl"
      [ngStyle]="{ fontSize }"
      placeholder="00"
      max="23"
      min="0"
      maxlength="2"
      pattern="[0-9]{1,2}"
      (input)="allowOnlyXCharsAndMaxNumber(hoursControl, hoursInput, 2, maxHours)"
      (click)="onInputClick($event, hoursInput)"
    />
    <span>:</span>
    <input
      #minutesInput
      class="time-input"
      type="number"
      [formControl]="minutesControl"
      [ngStyle]="{ fontSize }"
      placeholder="00"
      max="59"
      min="0"
      maxlength="2"
      pattern="[0-9]{1,2}"
      (input)="allowOnlyXCharsAndMaxNumber(minutesControl, minutesInput, 2, 59)"
      (click)="onInputClick($event)"
    />
    @if (secondsControl) {
      <span>:</span>
      <input
        #secondsInput
        class="time-input"
        type="number"
        [formControl]="secondsControl"
        [ngStyle]="{ fontSize }"
        placeholder="00"
        max="59"
        min="0"
        maxlength="2"
        pattern="[0-9]{1,2}"
        (input)="allowOnlyXCharsAndMaxNumber(secondsControl, secondsInput, 2, 59)"
        (click)="onInputClick($event)"
      />
    }
    @if (icon) {
      <span class="icon icon-time" [inlineSVG]="'/icons/icon-time.svg'"></span>
    }
  </div>
  <!-- <div class="error-container">
  <mat-error *ngIf="form.invalid && form?.errors?.creditsTimeInvalid">
    {{ 'movie_schedular.form.error.credits_start_exceed_movie_duration' | transloco }}
  </mat-error>
</div> -->
</div>
